import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props} viewBox='0 0 40 55'>
    <path d='m40.37508,2.5l-40.75017,0l0,35.04829l20.37509,14.95171l20.37508,-14.95171l0,-35.04829zm-4.62877,32.70382l-15.74631,11.55496l-15.74632,-11.55496l0,-28.07505l31.49263,0l0,28.07505zm-18.06233,-3.33152l14.00975,-11.9538l-3.00484,-3.52173l-11.27415,9.62091l-6.20332,-4.37728l-2.66849,3.78248l9.14105,6.44942z' />
  </SvgIcon>
)
